// import {invoke} from "@Utility/native-api-promise"
import nativeApi from "@/utils/native-api"


function setNavigationBarColor(tintColor, tintColorStyle = false, statusBarStyle = false) {
  let params = {
    tintColor
  }

  if (tintColorStyle) {
    params.tintColorStyle = tintColorStyle
  }

  if (statusBarStyle) {
    params.statusBarStyle = statusBarStyle
  }

  nativeApi.invoke("setNavigationBarTintColor", params)
}

export default {
  created: function() {
    setTimeout(() => {
      //设置白色导航
      if (this.navigationBarColor == '255,255,255,1') {
        nativeApi.invoke('getDeviceInfo').then((result) => {
          if (result && result.version >= "6.2.2") {
            setNavigationBarColor(this.navigationBarColor, '1', '1')
          }
        })
      } else {
        setNavigationBarColor(this.navigationBarColor)
      }
    }, 100)
  }
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/goldSale/mixin/setNavigationBarColor.js